import { useEffect, useState } from "react";
import api from "../../services/api";
import Loading from "../../load/loading";
import {
  Card,
  Grid,
  MenuItem,
  Paper,
  TextField,
} from "@mui/material";
import { Typography, Avatar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import HeaderSession from "../../utils/headerSession";
import RegisterAccess from "../../utils/registerAccess";
import { RelatorioAdministadoresPdf } from "../exports/gerarelatoriopdf";
import { RelatorioAdministadoresExcel } from "../exports/gerarelatorioexcel";
import FichaAdmin from "./fichaAdmin";
import Paginacao from "../../utils/paginacao";
import { useNavigate, useSearchParams } from "react-router-dom";
import { IconButton, DialogActions } from "@mui/material";
import ReorderOutlinedIcon from '@mui/icons-material/ReorderOutlined';
import GridOnOutlinedIcon from '@mui/icons-material/GridOnOutlined';
import { makeStyles } from "@material-ui/core";
import { useSelector } from "react-redux";
import { temPermissao } from "../../utils/permissoes";

const useStyles = makeStyles((theme) => ({
  hover: { '&:hover': { backgroundColor: '#85287d8a' }, cursor: 'pointer' }
}))

export default function ListaFuncionarios() {
  const user = useSelector((state) => state.account.user);
  const classes = useStyles()
  const [admins, setAdmins] = useState([]);
  const [status, setStatus] = useState("");
  const [funccao, setFunccao] = useState("");
  const [funcoes, setFuncoes] = useState([]);
  const [handleUpdate, setHandleUpdate] = useState('');
  const [configLista, setConfigLista] = useState('');
  const [searchParams] = useSearchParams();
  const [page, setPage] = useState(searchParams.get("page"));
  const [perPage, setPerPage] = useState(20);
  const [list_grelha, setList_grelha] = useState('list')
  const navigate = useNavigate()

  useEffect(() => {
    setAdmins([]);
    api
      .get(`/admins?status=${status}&funcao=${funccao}&perPage=${perPage}&page=${page}`)
      .then((response) => {
        setConfigLista(response.data);
        setAdmins(response.data.Admins);

        // Extrair funções únicas dos administradores
        const uniqueFuncoes = [
          ...new Set(response.data.Admins.map((admin) => admin.funcao)),
        ];
        setFuncoes(uniqueFuncoes);
      })
      .catch((err) => console.error("Erro ao buscar funcionários:", err));
  }, [status, funccao, handleUpdate, page, perPage]); // Sempre que status ou funccao mudar, a busca será feita automaticamente

  return (
    <>
      <RegisterAccess page={"lista de funcionarios"} />

      <HeaderSession
        title={"USUARIOS ADMINISTRADORES DO SISTEMA"}
        actions={true}
        handleExportExcel={() => RelatorioAdministadoresExcel(admins)}
        handleExportPDF={() => RelatorioAdministadoresPdf(admins)}
      />

      <div>
        {/* Filtros */}
        <Grid container spacing={2} style={{ marginBottom: '10px' }}>
          <Grid item xs={12} sm={6} md={2}>
            <TextField
              size="small"
              select
              fullWidth
              label="Estado"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              variant="outlined"
            >
              <MenuItem value="">Todos</MenuItem>
              <MenuItem value="Activo">Ativo</MenuItem>
              <MenuItem value="Inactivo">Inativo</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <TextField
              size="small"
              select
              fullWidth
              label="Função"
              value={funccao}
              onChange={(e) => setFunccao(e.target.value)} // Apenas atualiza o estado
              variant="outlined"
            >
              <MenuItem value="">Todas as Funções</MenuItem>
              {funcoes.map((funcao) => (
                <MenuItem key={funcao} value={funcao}>
                  {funcao}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <DialogActions>
            {list_grelha === 'grid' ?
              <IconButton title='Ver em lista' onClick={() => setList_grelha('list')} className='hover:bg-transparent'>
                <ReorderOutlinedIcon fontSize="large" />
              </IconButton>
              :
              <IconButton title='Ver em grelha' autoFocus onClick={() => setList_grelha('grid')} className='hover:bg-transparent'>
                <GridOnOutlinedIcon fontSize="large" />
              </IconButton>
            }
          </DialogActions>
        </Grid>

        {admins.length > 0 ?
          <>
            {list_grelha === 'list' &&
              <TableContainer sx={{ border: "1px black" }} component={Paper}>
                <Table sx={{ border: "1px", borderColor: "black" }}>
                  <TableHead sx={{ backgroundColor: "#dcdede" }}>
                    <TableRow>
                      <TableCell ><Typography noWrap> </Typography></TableCell>
                      <TableCell ><Typography noWrap> <strong>Nome</strong></Typography></TableCell>
                      {/* <TableCell ><Typography noWrap> <strong>BI</strong></Typography></TableCell> */}
                      <TableCell ><Typography noWrap> <strong>Departamento</strong></Typography></TableCell>
                      <TableCell ><Typography noWrap> <strong>Secção</strong></Typography></TableCell>
                      <TableCell ><Typography noWrap> <strong>Agente</strong></Typography></TableCell>
                      <TableCell ><Typography noWrap> <strong>Telefone1</strong></Typography></TableCell>
                      {/* <TableCell ><Typography noWrap> <strong>Telefone2</strong></Typography></TableCell> */}

                      <TableCell ><Typography noWrap> <strong>E-mail</strong></Typography></TableCell>
                      <TableCell ><Typography noWrap> <strong>Provincia</strong></Typography></TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {admins.map((admin) => (
                      <TableRow key={admin?._id} className={classes.hover} onClick={() => navigate(temPermissao(user, ['acessarPerfilsUser']) ? `/admin/perfil-admin/${admin?._id}` : '#')} title={admin?.nome}>

                        <TableCell component="th" scope="row">
                          <Avatar src={admin?.dadosPessoais.fotoURL} alt={admin?.nome} />
                          {/* {admin?.dadosPessoais?.nome} */}
                        </TableCell>

                        <TableCell >{admin?.dadosPessoais?.nome}</TableCell>
                        {/* <TableCell >{admin?.dadosPessoais?.numeroBI}</TableCell> */}
                        <TableCell >{admin?.departamento}</TableCell>
                        <TableCell >{admin?.seccao}</TableCell>
                        <TableCell >{admin?.numeroAgente}</TableCell>
                        <TableCell >{admin?.dadosPessoais?.tel1}</TableCell>
                        <TableCell >{admin?.dadosPessoais?.email}</TableCell>
                        <TableCell >{admin?.dadosPessoais?.provincia}</TableCell>

                      </TableRow>
                    ))}
                  </TableBody>
                </Table>

                <Paginacao
                  configLista={configLista}
                  lista={admins}
                  page={page}
                  setPage={setPage}
                  setPerPage={setPerPage}
                />
              </TableContainer>
            }

            {list_grelha === 'grid' &&
              <>
                <Grid style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center' }}>
                  {admins.map((admin) => (
                    <FichaAdmin local={'perfilAdmin'} key={admin._id} admin={admin} setHandleUpdate={setHandleUpdate} list={true} />
                  ))}
                </Grid>
                <Card style={{ marginBottom: 10, width: '98%', margin: 'auto' }}>
                  <Paginacao
                    configLista={configLista}
                    lista={admins}
                    page={page}
                    setPage={setPage}
                    setPerPage={setPerPage}
                  />
                </Card>
              </>
            }

          </>
          : <Loading text={'A carregar administradores cadastrados...'} />
        }

      </div>
    </>
  );
}
